module.exports = __webpack_public_path__ + "img/activateWarn.2e270dea.svg";